import { Observable } from 'rxjs';
import { CustomerImpersonationSearchParams, ImpersonationCustomerPage } from '../models/asm-impersonation.models';

export abstract class AsmImpersonationAdapter {
  abstract customerImpersonationSearch(options: CustomerImpersonationSearchParams): Observable<ImpersonationCustomerPage>;
}
